import { render, staticRenderFns } from "./Virtuell.vue?vue&type=template&id=aea9bcf2&scoped=true&"
import script from "./Virtuell.vue?vue&type=script&lang=js&"
export * from "./Virtuell.vue?vue&type=script&lang=js&"
import style0 from "./Virtuell.vue?vue&type=style&index=0&id=aea9bcf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea9bcf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VLayout,VRow})
